ItemorderController.$inject= ['$uibModal'];
export default function ItemorderController($uibModal) {
    var ctrl = this;
    ctrl.open = function() {
        $uibModal.open({
            component: "itemorderModal",
            resolve: {
                params: function() {
                    return {
                        text: ctrl.text,
                        docid: ctrl.docid,
                        opacrecord: ctrl.opacrecord
                    };
                }
            },
            size: 'lg'
        }).result.then(function(result) {
            console.info("I was closed, so do what I need to do myContent's controller now.  Result was->" );
            console.info(result);
            ctrl.onDone(result);
        }, function(reason) {
            console.info("I was dimissed, so do what I need to do myContent's controller now.  Reason was->" + reason);
        });
    };
}
